export default "__VITE_ASSET__d29d042a__"